/* eslint-disable no-use-before-define */
const factory = ngDialog => {
  function openConfirm(icon, title, message, actionLabel, action) {
    const dialog = ngDialog.openConfirm({
      className: 'bl-full-screen-confirm',
      closeByNavigation: false,
      plain: true,
      appendTo: '[ng-app]',
      overlay: false,
      template: `
          <bl-full-screen-confirm-dialog
            icon='${icon}'
            title='${title}'
            message='${message}'
            action-label='${actionLabel}'
            dialog-ref='${dialog}'
          />`,
      preCloseCallback: action,
    });
  }

  const service = {
    openConfirm,
  };

  return service;
};

const deps = [require('ui/web/fullScreenConfirmDialog').name];

module.exports = angular
  .module('bench.util.fullScreenConfirmDialogService', deps)
  .factory('FullScreenConfirmDialogService', factory);
